import { secondsToMilliseconds } from 'date-fns';
import type { PropsWithChildren, ReactNode } from 'react';

import { ContentAfterDelay } from '../confirmation/page';

/**
 * Multi-stage progress bar
 *
 * @param props
 * @returns
 */
export function LoadingProgressBar({ children }: PropsWithChildren): ReactNode {
	return (
		<ContentAfterDelay delay={secondsToMilliseconds(7)} label={children} color={'blue.9'}>
			<ContentAfterDelay delay={secondsToMilliseconds(13)} label={children} color={'orange.9'}>
				<ContentAfterDelay delay={secondsToMilliseconds(20)} label={children} color={'red.9'} />
			</ContentAfterDelay>
		</ContentAfterDelay>
	);
}
